import React from 'react';
import { IDSTabs, IDSTab, IDSTabPanel } from '@inera/ids-react';
import QuestionsAdminLayout from '../components/administration/QuestionsAdminLayout';
import ContractQuestionsAdminLayout from '../components/administration/ContractQuestionsAdminLayout';

function QuestionsAdminPage() {
  return (
    <main className="ids-content ids-p-6" style={{ maxWidth: '900px', margin: '2rem auto' }}>
      <h1 className="ids-heading-l ids-mb-4">Administrera frågor</h1>

      <IDSTabs breakpoint="m" tabs={[
        <IDSTab key="by-contract" label="Per kontrakt" />,
        <IDSTab key="all" label="Alla sektioner" />
      ]}>
        <IDSTabPanel noFocus>
          <ContractQuestionsAdminLayout />
        </IDSTabPanel>
        <IDSTabPanel noFocus>
          <QuestionsAdminLayout embedded />
        </IDSTabPanel>
      </IDSTabs>
    </main>
  );
}

export default QuestionsAdminPage;
